import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-help-modal',
  templateUrl: './help-modal.component.html',
  styleUrls: ['./help-modal.component.scss']
})
export class HelpModalComponent {
  @Input() adminName: string = '';
  @Input() adminEmail: string = '';
  @Output() close = new EventEmitter<void>();

  copySuccess: boolean = false;

  onClose(): void {
    this.close.emit();
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.copySuccess = true;
      setTimeout(() => { this.copySuccess = false; }, 2000);
    }).catch(err => {
      console.error('Failed to copy:', err);
    });
  }
}
